import React, { useState } from 'react';
import { ChevronLeft, ChevronRight, Quote, Star } from 'lucide-react';
import { testimonials } from '../mock';

const Testimonials = () => {
  const [idx, setIdx] = useState(0);
  const prev = () => setIdx((i) => (i - 1 + testimonials.length) % testimonials.length);
  const next = () => setIdx((i) => (i + 1) % testimonials.length);
  const t = testimonials[idx];

  return (
    <section className="py-20 md:py-24 bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="font-display text-3xl md:text-5xl font-bold text-center text-brand-navy uppercase title-underline">
          Cosa Dicono i Nostri Clienti
        </h2>

        <div className="mt-14 relative">
          <div className="bg-white rounded-xl shadow-lg p-8 md:p-12 relative">
            <div className="absolute -top-5 left-8 w-12 h-12 rounded-full bg-brand-red flex items-center justify-center shadow-lg">
              <Quote className="w-6 h-6 text-white" />
            </div>
            <p className="mt-4 text-lg md:text-xl text-gray-700 italic leading-relaxed">&ldquo;{t.text}&rdquo;</p>
            <div className="mt-6 flex items-center justify-between flex-wrap gap-4">
              <div>
                <p className="font-display font-bold text-brand-navy text-lg">— {t.name}</p>
                <p className="text-sm text-gray-500">{t.location}</p>
              </div>
              <div className="flex gap-1">
                {Array.from({ length: t.rating }).map((_, i) => (
                  <Star key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" />
                ))}
              </div>
            </div>
          </div>

          <div className="flex justify-center gap-3 mt-6">
            <button onClick={prev} aria-label="Slide precedente" className="w-11 h-11 rounded-full bg-white border border-gray-200 hover:border-brand-red hover:text-brand-red transition-colors flex items-center justify-center shadow-sm">
              <ChevronLeft className="w-5 h-5" aria-hidden="true" />
            </button>
            <div className="flex items-center gap-2">
              {testimonials.map((_, i) => (
                <button
                  key={i}
                  onClick={() => setIdx(i)}
                  aria-label={`Vai alla slide ${i + 1}`}
                  aria-current={idx === i ? 'true' : undefined}
                  className={`w-2.5 h-2.5 rounded-full transition-all ${i === idx ? 'bg-brand-red w-8' : 'bg-gray-300'}`}
                />
              ))}
            </div>
            <button onClick={next} aria-label="Slide successiva" className="w-11 h-11 rounded-full bg-white border border-gray-200 hover:border-brand-red hover:text-brand-red transition-colors flex items-center justify-center shadow-sm">
              <ChevronRight className="w-5 h-5" aria-hidden="true" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
